import { render, staticRenderFns } from "./Curriculumvitae.vue?vue&type=template&id=142421e6&scoped=true&"
import script from "./Curriculumvitae.vue?vue&type=script&lang=js&"
export * from "./Curriculumvitae.vue?vue&type=script&lang=js&"
import style0 from "./Curriculumvitae.vue?vue&type=style&index=0&id=142421e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142421e6",
  null
  
)

component.options.__file = "Curriculumvitae.vue"
export default component.exports